import type { Address } from '@src/core/buyerApiClient';
import { getCepAddress } from '@src/common/auth';
import { normalizeForeignPostalCode, normalizeZipCode, buildForeignAddress } from '@src/domains/customers';

/**
 * Resolves an address from the zip code (shared by signup and payment).
 *
 * Foreign, or no zip code: only the zipCode (no address). Brazilian with a zip
 * code: looks it up on Brasil API, falling back to an empty address if it fails.
 *
 * Address resolution only — the zip-code length validation (isValidZipCode) stays
 * with the caller, which decides when and how to block the submit.
 */
export async function resolveAddress(zipCode: string | null | undefined, isForeign: boolean): Promise<Address> {
  const cleaned = isForeign ? normalizeForeignPostalCode(zipCode) : normalizeZipCode(zipCode);

  if (isForeign || !cleaned) {
    return buildForeignAddress(cleaned);
  }

  try {
    return await getCepAddress(cleaned);
  } catch (err) {
    console.error('CEP lookup failed; using fallback address', err instanceof Error ? err.message : err);
    return buildForeignAddress(cleaned);
  }
}
